// @flow

import i18n from '../i18n';

export const validatePhone = (value: string | null) => {
  if (!value) {
    return undefined;
  }
  const matchNumbers = value.match(/\d/g);
  const matchLetters = value.match(/[A-Za-z]/g);
  if (value.length > 20
    || (matchLetters && matchLetters.length > 0)
    || !matchNumbers || matchNumbers.length !== 10) {
    return i18n.t('validPhone');
  }

  return undefined;
};

export const normalizePhone = (value: string | null) => {
  if (value === null || value.trim().length === 0) {
    return null;
  }

  const numbersInValue = value.replace(/[^\d]/g, '');
  if (numbersInValue.length <= 3) {
    return numbersInValue;
  }
  if (numbersInValue.length <= 7) {
    return `${numbersInValue.slice(0, 3)}-${numbersInValue.slice(3)}`;
  }
  return `${numbersInValue.slice(0, 3)}-${numbersInValue.slice(3, 6)}-${numbersInValue.slice(6)}`;
};
